export const createStocktakeQuantitySelectorStyles = ({ ui: { colors, type, space, radius, touch, elevation } }) => ({
	container: {
		marginTop: space.md,
	},
	label: {
		...type.overline,
		color: colors.textSecondary,
		marginBottom: 6,
		textTransform: 'uppercase',
	},
	inputsRow: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginTop: space.md,
	},
	inputContainer: {
		flexGrow: 1,
		flexBasis: '30%',
		marginBottom: space.md,
		minWidth: 110,
	},
	inputContainerSpacing: {
		marginRight: space.md,
	},
	inputLabel: {
		...type.overline,
		marginBottom: 6,
		color: colors.textSecondary,
		textTransform: 'uppercase',
	},
	packagingPickerButton: {
		width: '100%',
	},
	packagingPickerModalBackdrop: {
		flex: 1,
		backgroundColor: colors.overlay,
		justifyContent: 'center',
		alignItems: 'center',
		padding: space.lg,
	},
	packagingPickerModalOverlay: {
		position: 'absolute',
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
	},
	packagingPickerModalContent: {
		width: '100%',
		maxWidth: 360,
		backgroundColor: colors.surface,
		borderRadius: radius.hero,
		paddingVertical: space.sm,
		...elevation.floating,
	},
	packagingPickerOption: {
		minHeight: touch.min,
		justifyContent: 'center',
		paddingVertical: space.md,
		paddingHorizontal: 20,
	},
	packagingPickerOptionText: {
		...type.body,
		color: colors.text,
	},
	packagingPickerOptionTextSelected: {
		...type.bodyStrong,
		color: colors.accent,
	},
});
